import angular from 'angular';

import Notifications from './notification/notification.directive';
import NotificationToast from './notification-toast/notification-toast.component';
import NotificationsWrap from './notifications-wrap/notifications-wrap.directive';

const DEPENDENCIES = [
  Notifications,
  NotificationToast,
  NotificationsWrap,
];

export default angular.module('autoboard.notifications', DEPENDENCIES)
  .name;
